<!--头信息-->
<template>
    <div class="header padding">
        <img src="../assets/images/common/logo.svg" alt="" class="icon">
        <span style="margin-left: 15px">足趣社区，满足你的一切兴趣</span>
        <div v-if="onDownClick">
            <a v-on:click="onDownClick()" href="javascript:void(0)" class="downloadButton">立即下载</a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            // 下载按钮点击事件
            onDownClick: [Function],
        }
    }
</script>
<style scoped>
    .header {
        height: 4rem;
        background: linear-gradient(270deg, rgba(118, 75, 248, 1) 0%, rgba(187, 58, 246, 1) 100%);
        width: 100%;
        display: flex;
        align-items: center;
        color: #FFF;
        box-sizing: border-box;
        padding: 0 1rem;
    }

    .header img {
        height: 2.4rem;
    }

    .header span {
        margin-left: 0.2rem;
    }

    .header div a {
        display: inline-block;
        padding: 0 0.5em;
        line-height: 1.6rem;
        border-radius: 0.7rem;
        text-align: center;
        color: #A081FF;
        background: #fff;
    }

    .header div {
        flex: 1;
        text-align: right;
    }
</style>
